import type { NewsCategoria } from "@/types/news";

const STYLES: Record<NewsCategoria, string> = {
  Novita: "bg-brand/10 text-brand-dark",
  Promo: "bg-green-100 text-green-700",
  Tecnico: "bg-blue-100 text-blue-700",
  Urgente: "bg-red-100 text-red-700",
};

const LABELS: Record<NewsCategoria, string> = {
  Novita: "NOVITÀ",
  Promo: "PROMO",
  Tecnico: "TECNICO",
  Urgente: "URGENTE",
};

export function CategoryBadge({
  categoria,
  size = "md",
}: {
  categoria: NewsCategoria;
  size?: "sm" | "md";
}) {
  const sizeClass = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  return (
    <span className={`inline-block rounded font-semibold ${STYLES[categoria]} ${sizeClass}`}>
      {LABELS[categoria]}
    </span>
  );
}
